import useTranslation from '../../hooks/useTranslation';

import { HorizontalContainer } from '@american-autonomy/ag-ui';

import GhostButton from 'components/buttons/GhostButton';
import PrimaryButton from 'components/buttons/PrimaryButton';

import { CLOSE_BUTTON_TEST_ID, PDF_BUTTON_TEST_ID, TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const ComplianceFooter: FunctionComponent<Props> = ({
    isPdfDisabled,
    onClose,
    onDownloadPdf,
    testId = TEST_ID
}) => {
    const translations = useTranslation();

    return (
        <HorizontalContainer className={styles.complianceFooter} testId={testId}>
            <GhostButton
                onClick={onClose}
                testId={CLOSE_BUTTON_TEST_ID}
                text={translations.CLOSE_BUTTON}
            />

            <PrimaryButton
                isDisabled={isPdfDisabled}
                onClick={onDownloadPdf}
                testId={PDF_BUTTON_TEST_ID}
                text={translations.DOWNLOAD_PDF_BUTTON}
            />
        </HorizontalContainer>
    );
};

export default ComplianceFooter;
